import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    data() {
        return {
            withdrawnApplication: {},
        }
    },
    methods: {
        ...mapActions({
            FetchWithdrawnApplicationByEnrolmentID: 'withdrawnApplication/FetchWithdrawnApplicationByEnrolmentID',
            UpsertWithdrawnApplication: 'withdrawnApplication/UpsertWithdrawnApplication',
        }),
        LoadWithdrawnApplication(enrolmentID) {
            eventBus.$emit(`withdrawn-application-fetch:${enrolmentID}:started`);
            this.FetchWithdrawnApplicationByEnrolmentID(enrolmentID)
                .then(response => {
                    this.withdrawnApplication = Object.assign({}, response);
                    eventBus.$emit(`withdrawn-application-fetch:${enrolmentID}:success`);
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit(`withdrawn-application-fetch:${enrolmentID}:finished`));
        },
        SaveWithdrawnApplication(withdrawnApplication) {
            eventBus.$emit(`withdrawn-application-save:${withdrawnApplication.enrolmentID}:started`);
            this.UpsertWithdrawnApplication(withdrawnApplication)
                .then(response => eventBus.$emit(`withdrawn-application-save:${withdrawnApplication.enrolmentID}:success`, response))
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit(`withdrawn-application-save:${withdrawnApplication.enrolmentID}:finished`));
        },
    }
};